const API_ENDPOINT = "https://ra.dga.jp/cgi-bin/ra/KAN069-JSONP-2";
const PROD_ORIGIN = "https://www.kobe-np.co.jp";

document.addEventListener('DOMContentLoaded', () => {
  fetchRelatedArticlesJSONP(window.location.pathname);
});

// JSONP API 呼び出し
function fetchRelatedArticlesJSONP(path) {
  const script = document.createElement('script');
  script.id = 'jsonp-relation-script';
  script.src = `${API_ENDPOINT}?cs=utf8&l=${PROD_ORIGIN}${path}`;

  window.relation = function(data) {
    renderRelatedArticles(data);
    delete window.relation;
    script.remove();
  };
  document.body.appendChild(script);
}

// 現在のホスト名からアセット用のドメインを決定する
function getAssetsDomainName() {
  const hostname = window.location.hostname;
  const devHosts = ['develop.kobe-np.co.jp', 'qa.kobe-np.co.jp', 'qa2.kobe-np.co.jp'];
  if (devHosts.includes(hostname)) {
    return '//' + window.location.host;
  } else {
    return '//i.kobe-np.co.jp';
  }
}

// 画像パスのプレフィックスを付け替える処理
function changeImagePrefix(imagePath, prefix = '') {
  const lastSlashIndex = imagePath.lastIndexOf('/');
  const dirname = lastSlashIndex !== -1 ? imagePath.substring(0, lastSlashIndex) : '';
  const basename = lastSlashIndex !== -1 ? imagePath.substring(lastSlashIndex + 1) : imagePath;
  const regex = /^([a-z]{1}_)?(\d{8}\.jpg)$/;
  const matches = basename.match(regex);

  if (matches) {
    const separator = dirname ? '/' : '';
    return dirname + separator + prefix + matches[2];
  } else {
    return imagePath;
  }
}

// HTMLを構築して挿入する処理
function renderRelatedArticles(relationData) {
  // データが無い場合はセクションを非表示のまま終了
  if (!relationData || relationData.length === 0) return;

  const ASSETS_DOMAIN_NAME = getAssetsDomainName(); // アセットドメインを取得

  // 全記事の <li> 要素のHTML文字列を一気に作成する
  let listItemsHtml = '';
  relationData.forEach(item => {
    let dataPay = 0;
    if (item.pay === 'gold') dataPay = 1;
    else if (item.pay === 'silver') dataPay = 2;
    else if (item.pay === 'bronze') dataPay = 3;

    let imageUrl = `${ASSETS_DOMAIN_NAME}/assets/img/nophoto-next.png`;
    if (item.image) {
      try {
        let path = item.image;
        if (item.image.startsWith('http')) {
          path = new URL(item.image).pathname;
        }
        path = changeImagePrefix(path, 'j_');
        // キャッシュバスターが必要な場合はここで付与
        // path += `?v=${new Date().getTime()}`;
        imageUrl = ASSETS_DOMAIN_NAME + path;
      } catch (e) {
        console.error("画像URLのパースエラー", e);
      }
    }

    listItemsHtml += `
      <li data-pay="${dataPay}" data-mov="0" data-photo="0">
        <a href="${item.url}" class="thumb">
          <img src="${imageUrl}" decoding="async" loading="lazy" alt="${item.title}">
        </a>
        <div class="detail">
          <a href="${item.url}" class="caption">${item.title}</a>
          <div class="pubmeta">
            <span class="ic pay"></span><span class="ic pho"></span><span class="ic mov"></span>
          </div>
        </div>
      </li>
    `;
  });

  // PC用のリストに挿入＆表示
  const pcSec = document.getElementById('related-sec-pc');
  const pcList = document.getElementById('related-list-pc');
  if (pcSec && pcList) {
    // 広告(li.ad-item)の直前に挿入
    pcList.insertAdjacentHTML('afterbegin', listItemsHtml);
    pcSec.style.display = ''; // セクションを表示
  }

  // SP用のリストに挿入＆表示
  const spSec = document.getElementById('related-sec-sp');
  const spList = document.getElementById('related-list-sp');
  if (spSec && spList) {
    spList.insertAdjacentHTML('afterbegin', listItemsHtml);
    spSec.style.display = ''; // セクションを表示
  }
}
